import { render, staticRenderFns } from "./CgrnCreate.vue?vue&type=template&id=4f0ea51f&scoped=true"
import script from "./CgrnCreate.vue?vue&type=script&lang=js"
export * from "./CgrnCreate.vue?vue&type=script&lang=js"
import style0 from "./CgrnCreate.vue?vue&type=style&index=0&id=4f0ea51f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0ea51f",
  null
  
)

export default component.exports